import { render, staticRenderFns } from "./ContentVideo.vue?vue&type=template&id=1e2df237&scoped=true"
import script from "./ContentVideo.vue?vue&type=script&lang=ts"
export * from "./ContentVideo.vue?vue&type=script&lang=ts"
import style0 from "./ContentVideo.vue?vue&type=style&index=0&id=1e2df237&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2df237",
  null
  
)

export default component.exports